/**** EC-238-[FE]  Sub Task - EC-775 Code injection ****/
import { savedOrderDetailsOrderInformationStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import { css } from "styled-components";

/*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
savedOrderDetailsOrderInformationStyles.orderInformationGridContainer = {
	css: css`
		margin: 10px 0;
	`
}

savedOrderDetailsOrderInformationStyles.shippingInformationGridItem = {
	css: css`
		padding: 7.5px 15px;
		max-width: 50%;
		flex-basis: 50%;
		flex-direction: column;
		@media print {
			all: unset;
			padding: 7.5px 15px;
		}
	`
}

savedOrderDetailsOrderInformationStyles.billingInformationGridItem ={
	css: css`
		padding: 7.5px 15px;
		max-width: 50%;
		flex-basis: 50%;
		flex-direction: column;
		@media print {
			all: unset;
			padding: 7.5px 15px;
		}
	`
}

savedOrderDetailsOrderInformationStyles.mainInformationGridItem = {
	width: 12,
	css: css`
		padding: 15px 15px;
		flex-direction: column;
	`
}
/*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */